import styled, { css } from "styled-components";
import { STATUS_TONES } from "./tones";

export type BadgeVariant =
  | "primary"
  | "accent"
  | "ghost"
  | "outline"
  | "available"
  | "pending"
  | "success"
  | "warning"
  | "danger"
  | "info";

const variants: Record<BadgeVariant, ReturnType<typeof css>> = {
  primary: css`
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primaryFg};
  `,
  accent: css`
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.senneWhite};
  `,
  ghost: css`
    background: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.gray600};
  `,
  outline: css`
    background: transparent;
    border: 2px solid ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.fg4};
  `,
  available: css`
    background: ${({ theme }) => theme.colors.tintAccent10};
    color: #7e8336;
    text-transform: uppercase;
    letter-spacing: 0.16em;
  `,
  pending: css`
    background: #fff7ed;
    color: ${({ theme }) => theme.colors.primary};
    text-transform: uppercase;
    letter-spacing: 0.16em;
  `,
  success: css`
    background: ${({ theme }) => theme.colors[STATUS_TONES.success.bg]};
    color: ${({ theme }) => theme.colors[STATUS_TONES.success.fg]};
  `,
  warning: css`
    background: ${({ theme }) => theme.colors[STATUS_TONES.warning.bg]};
    color: ${({ theme }) => theme.colors[STATUS_TONES.warning.fg]};
  `,
  danger: css`
    background: ${({ theme }) => theme.colors[STATUS_TONES.danger.bg]};
    color: ${({ theme }) => theme.colors[STATUS_TONES.danger.fg]};
  `,
  info: css`
    background: ${({ theme }) => theme.colors[STATUS_TONES.info.bg]};
    color: ${({ theme }) => theme.colors[STATUS_TONES.info.fg]};
  `,
};

export const Root = styled.span<{ $variant: BadgeVariant }>`
  display: inline-block;
  padding: 6px 18px;
  border-radius: ${({ theme }) => theme.radii.pill};
  font-family: ${({ theme }) => theme.typography.fontBody};
  font-size: 11px;
  font-weight: ${({ theme }) => theme.typography.fw.bold};
  ${({ $variant }) => variants[$variant]}
`;

/** A count that asks for attention (tabs, menu, bell): solid brand colour, white figure (spec 20261028-130000 AC-5). */
export const CountRoot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.radii.pill};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryFg};
  font-family: ${({ theme }) => theme.typography.fontBody};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.typography.fw.bold};
  line-height: 1;
`;
